
import React, { useState, useRef,useEffect } from "react";
import "./FileUploader.css";
import { Globals as OldGlobals } from "../../global/Globals";
import { useLocation } from "react-router-dom";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const FileUploader = ({ checkForValidFile, fileDownload, onFileUpload, className, selectedClassName, tabIndex, supportedFileType,onFileRemove,onClick2, isPreloadedFile=false, preDefinedFile=null, isFromRegPage, onCheckForFile, isLogoHolder=false }) => {
  const lang=localStorage.getItem('lang');
  const { Globals } = useLanguage();
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(fileDownload?{name:fileDownload?.[0]?.documentName}:null);
  const [dragging, setDragging] = useState(false);
  const [acceptedFiles, setAcceptedFiles]=useState('')
  const [toggle, setToggle] = useState(true); // State to track toggle status
  const location = useLocation();

  const isIndividualEditPage = location.pathname.includes("edit-company");
  const isProductionEditPage = location.pathname.includes("edit-producer");
  const isEditPage = isIndividualEditPage || isProductionEditPage;
 const [errorMessage, setErrorMessage] = useState(""); // State for error message
  let extraProps = {};
  if (tabIndex) {
    extraProps.tabIndex = tabIndex; // Use correct casing
  }

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    console.log("File ===> ", selectedFile);
    if (!selectedFile) return;
    const validFormats = acceptedFiles.split(", ");
  const isValidFormat = validFormats.some((format) => {
    // Match the exact MIME type or file extensions
    return selectedFile.type === format.trim() || selectedFile.name.endsWith(format.trim());
  });

    if (isValidFormat) {
      // setFile(selectedFile);
      setErrorMessage(""); // Clear any existing error message
        const maxSizeInMB = 500;
        const fileSizeInMB = selectedFile.size / (1024 * 1024); // Convert from bytes to MB
        if (fileSizeInMB > maxSizeInMB) {
          setErrorMessage(`${Globals.MAX_FILE_SIZE_ERROR}`); // Set error message
          console.error("Invalid file format:", selectedFile.type);
    }else if(!maxSizeInMB){
      setErrorMessage(`${Globals.MIN_FILE_SIZE_ERROR}`); // Set error message
    }
    else {
      if (Globals.SUPPORTED_IMAGES.includes(selectedFile.type)) {
        setFile(selectedFile);
      }
      else if (Globals.SUPPORTED_FILES.includes(selectedFile.type)) {
        setFile(selectedFile);
      }
      else if(Globals.SUPPORTED_PDF_DOC_FILES.includes(selectedFile.type)){
        setFile(selectedFile)
      }
      else if(Globals.SUPPORTED_VIDEO_FORMATS.includes(selectedFile.type)){
        setFile(selectedFile)
      }
      if (selectedFile.name.length > 0 && onFileUpload) {
        onFileUpload(selectedFile);
      }
      }
  
    } else {
      setErrorMessage(`${Globals.FILE_ERROR_PART1} ${validFormats.join(", ")} ${Globals.FILE_ERROR_PART2}`); // Set error message
      setFile(null);
      onFileUpload(null);
      console.error("Invalid file format:", selectedFile.type);
    }
    
    console.log("Selected File:", selectedFile);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => setDragging(false);

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const droppedFile = event.dataTransfer.files[0];
    if (!droppedFile) return;

    //setFile(droppedFile);
    if (onFileUpload) {
      onFileUpload(droppedFile);
    }
    const selectedFile = droppedFile;
    const validFormats = acceptedFiles.split(", ");
    const isValidFormat = validFormats.some((format) => {
      // Match the exact MIME type or file extensions
      return selectedFile.type === format.trim() || selectedFile.name.endsWith(format.trim());
    });

    if (isValidFormat) {
      // setFile(selectedFile);
      setErrorMessage(""); // Clear any existing error message
      const maxSizeInMB = 500;
      const fileSizeInMB = selectedFile.size / (1024 * 1024); // Convert from bytes to MB
      if (fileSizeInMB > maxSizeInMB) {
        setErrorMessage(`The file size exceeds the 500MB limit. Please upload a smaller file.`); // Set error message
        console.error("Invalid file format:", selectedFile.type);
      } else if (!maxSizeInMB) {
        setErrorMessage(`File size should be greater than 0MB`);
      }
      else {
        if (Globals.SUPPORTED_IMAGES.includes(selectedFile.type)) {
          setFile(selectedFile);
        }
        else if (Globals.SUPPORTED_FILES.includes(selectedFile.type)) {
          setFile(selectedFile);
        }
        else if (Globals.SUPPORTED_PDF_DOC_FILES.includes(selectedFile.type)) {
          setFile(selectedFile)
        }
        else if (Globals.SUPPORTED_VIDEO_FORMATS.includes(selectedFile.type)) {
          setFile(selectedFile)
        }
        if (selectedFile.name.length > 0 && onFileUpload) {
          onFileUpload(selectedFile);
        }
        if(checkForValidFile){
        checkForValidFile("valid");
      }
      }
    } else {
      setErrorMessage(`${Globals.FILE_ERROR_PART1} ${validFormats.join(", ")} ${Globals.FILE_ERROR_PART2}`); // Set error message
      console.error("Invalid file format:", selectedFile.type);
      if(checkForValidFile){
        checkForValidFile("invalid");
      }
      setFile(null);
      onFileUpload(null);
    }
    console.log("Selected File:", selectedFile);
  };

  // const deleteSelectedFile = () => setFile(null);

  useEffect(()=>{
    if(supportedFileType==='ImagesOnly'){
      setAcceptedFiles("image/*,image/jpg, image/jpeg, image/png, image/gif, img/svg, img/svg+xml")
  }else if(supportedFileType==="VideosOnly"){
      setAcceptedFiles(".mp4")
    }else if(supportedFileType==='pdfOrDocOnly'){
      setAcceptedFiles( ".doc, .docx, .pdf, .ppt , .pptx")
    }
    else{
        setAcceptedFiles(".jpg, .jpeg, .png, .gif, .doc, .docx, .pdf, .ppt, .pptx")
    }
  },[])
  const deleteSelectedFile = () => {
    setFile(null);
    if (onFileRemove) {
      onFileRemove();
    }
    if (isPreloadedFile) {
      setFile(null);
    }
    if (isFromRegPage) {
      onFileUpload(null);
    }
  };

  const onClick1 = (file) => {
    // setFile(null);
    if (onClick2) {
      onClick2();
    }
  };

  useEffect(() => {
    if (isPreloadedFile) {
      setFile(preDefinedFile);
    }
    if (!toggle && isPreloadedFile) {
      console.log("Toggle changed to no, clearing preDefinedFile");
      setFile(null);
    }
  }, [isPreloadedFile, toggle]);

  return (
    <>
      {!file ? (<>
        <div className={`file-upload-main ${className}`}>
          <div
             className={`file-upload-frame ${className} ${dragging ? 'dragging' : ''} ${isEditPage ? 'file-upload-frame-edit dragging' : ''}`}
            
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <input
              type="file"
              accept={acceptedFiles}
              ref={fileInputRef}
              onChange={handleFileChange}
              style={{
                opacity: 0,
                position: "absolute",
                width: "1px",
                height: "1px",
              }}
            />
            <div>
              <div className={`file-upload-group  ${isLogoHolder ? `${lang}-logo-upload` : ''}`}>
                <button
                  id="upload-btn"
                  className="upload-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    fileInputRef.current?.click();
                  }}
                  {...extraProps}
                >
                  <img
                    id="upload-img"
                    className="upload-img"
                    src={Globals.IMG.FILE_UPLOAD}
                    alt="upload"
                  />
                  <p className="upload-btn-text">{Globals.FILE_UPLOADER.UPLOAD}</p>
                </button>
                <div className="drop-files">
                  <label id="drop-files-holder" className={`drop-files-holder dropfile-${lang}`}>
                    {Globals.FILE_UPLOADER.DROP_FILES}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        {errorMessage && <div><p className="invalidCredential" style={{margin:"3.5px 0px",display:'flex',alignItems:'justify-content'}}> <img id="login-error" className="icon-style login-error" src={Globals.IMG.ERROR} alt="password error" style={{marginTop:"1.5px"}}/><span>{errorMessage}</span></p></div>}{" "}
        {/* Display error */}</>
      ) : (
        <div id="uploaded-files-frame" onClick={(e)=>{e.preventDefault(); onClick1(file?.name)}} className={`uploaded-files-frame ${selectedClassName} ${(window.location.pathname===Globals.NAVPATH.APPLY_BRIEF||window.location.pathname===Globals.NAVPATH.CREATE_UNSOLICITED|| window.location.pathname===Globals.NAVPATH.EDIT_BRIEF || window.location.pathname===Globals.NAVPATH.EDIT_UNSOLICITED || window.location.pathname===OldGlobals.NAVPATH.RAISE_TICKET)?'uploaded-files-frame-brief-page':''}`} >
          <div className={`afterupload ${(window.location.pathname===Globals.NAVPATH.APPLY_BRIEF||window.location.pathname===Globals.NAVPATH.CREATE_UNSOLICITED|| window.location.pathname===Globals.NAVPATH.EDIT_BRIEF || window.location.pathname===Globals.NAVPATH.EDIT_UNSOLICITED || window.location.pathname===OldGlobals.NAVPATH.RAISE_TICKET)?'afterupload-brief-page':''}`} style={{width:`${isFromRegPage&&"250px"}`}} >
            <img id="file-icon" className="file-icon" src={Globals.IMG.FILE} alt="file" />
            <span className="upload-file">{file?.name}</span>
            <img
              id="delete-file-btn"
              className="delete-file-btn"
              src={Globals.IMG.DELETE_FILE}
              alt="delete"
              onClick={deleteSelectedFile}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default FileUploader;
